module.exports = __webpack_public_path__ + "static/media/sample_company.518025b7.svg";